module.exports = __webpack_public_path__ + "img/Want to join our team.fbdb0168.jpg";